module.exports = __webpack_public_path__ + "static/media/classic-new-connected-app.f6f7da43.gif";